<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <div class="title">
      <h2>Legenda Calendari</h2>
    </div>
    <div class="calendars">
      @for (calendar of calendars; track calendar) {
        <div class="calendar-row">
          <div
            class="sphere"
            [ngStyle]="{ 'background-color': calendar.backgroundColor }"
          ></div>
          <span>{{ calendar.summary }}</span>
        </div>
      }
    </div>

    <div class="panel-buttons">
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('close')"
        (click)="onClose()"
      ></app-button>
    </div>
  </div>
</div>
